import { render, staticRenderFns } from "./FaqCollapse.vue?vue&type=template&id=7765c3de&scoped=true&"
import script from "./FaqCollapse.vue?vue&type=script&lang=js&"
export * from "./FaqCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7765c3de",
  null
  
)

export default component.exports